const PrintDirective = angular.module("PrintDirective", []).directive("printSection", printSection);

/**
 *
 *
 * Modified from http://blogs.microsoft.co.il/gilf/2014/08/09/building-a-simple-angularjs-print-directive/
 */
function printSection() {
    let container = document.getElementById("printSection");

    // if there is no printing section, create one
    if (!container) {
        container = document.createElement("div");
        container.id = "printSection";
        document.body.appendChild(container);
    }

    const link = function (scope, element, attrs) {
        element.on("click", function () {
            // clean the print section before adding new content
            container.innerHTML = "";

            const elemToPrint = document.getElementById(attrs.printElementId);
            if (elemToPrint) {
                const domClone = elemToPrint.cloneNode(true);
                container.appendChild(domClone);
                const getSVGDefs = container.querySelector(
                    "#" + attrs.printElementId + " svg defs"
                );
                if (getSVGDefs) {
                    // add random number to svg def id's to render properly for cloned elemToPrint
                    // this is only if the svg element we're rendering has def id's
                    for (let i = 0; i < getSVGDefs.childNodes.length; i++) {
                        const getSVGDefID = getSVGDefs.childNodes[i].id;
                        getSVGDefs.childNodes[i].id =
                            getSVGDefID + (Math.floor(Math.random() * 90000) + 10000);
                        container.innerHTML = container.innerHTML.replace(
                            new RegExp(getSVGDefID, "g"),
                            getSVGDefs.childNodes[i].id
                        );
                    }
                }
                window.print();
            }
        });
    };

    return {
        restrict: "A",
        link: link
    };
}

export default PrintDirective;
